import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CardFormat from '../enrolments/cardFormat';
import CardFormats from '../enrolments/cardFormats';
import EmailAccount from './EmailAccount';
import MobileAccount from './MobileAccount';
import MobileAccounts from './MobileAccounts';
import Holiday from './holiday';
import Holidays from './holidays';
import Message from './message';
import Messages from './messages';
import Site from './site';
import Sites from './sites';
import SecurityPolicies from "./SecurityPolicies";
import SecurityPolicy from "./SecurityPolicy";
import Events from './events';
import { MESSAGE_TYPES } from '@/constants/messages-constants';
import ExpiryReasons from './expiryReasons';
import ExpiryReason from './expiryReason';

function getPageForRoute(key: string, selectedTab: number, setSelectedTab: React.Dispatch<React.SetStateAction<number>>) {
    const selected = {
        'account': <MobileAccount />,
        'accounts': <MobileAccounts />,
        'card-format': <CardFormat />,
        'card-formats': <CardFormats />,        
        'holidays': <Holidays />,
        'holiday': <Holiday />, 
        'messages': <Messages selected={selectedTab} setSelected={setSelectedTab} />,
        'message': <Message messageType={MESSAGE_TYPES.ALL}  />,
        'general': <Message messageType={MESSAGE_TYPES.GENERAL} />,
        'biometric-message': <Message messageType={MESSAGE_TYPES.BIOMETRIC} />,
        'compliance-condition': <ExpiryReason />,
        'operational-compliance': <ExpiryReasons />,
        'site': <Site />,
        'sites': <Sites />,
        'account-setup': <EmailAccount/>,
        'security-policies':<SecurityPolicies/>,
        'security-policy':<SecurityPolicy/>,
        'events': <Events />,
    }[key];

    if (selected) { return selected; }
    return <div style={{ marginLeft: "20px", marginTop: "20px" }}>This page is not available yet</div>
}

function getKeyFromPath(path) {
    const contentKey = 3;
    const key = path.split('/')[contentKey];
    return key;
}

const ConfigurationIndex = () => {
    const page = useSelector((state: any) => state.router.location.pathname);
    const [selectedTab, setSelectedTab] = useState<number>(0)
    return getPageForRoute(getKeyFromPath(page), selectedTab, setSelectedTab);
};

export default ConfigurationIndex;
